export default "__VITE_ASSET__CsWsGhyD__"